import * as methods from 'api/core/actions';
import type {
  HourState,
  HourStatePermission,
  HourStatePermissionsPayload,
} from 'redux/modules/hourStates.schema';

export async function getHourStates(): Promise<Array<HourState>> {
  return methods.Get(`hours/states`);
}

export async function createHourState(state: Partial<HourState>): Promise<HourState> {
  return methods.Post('hours/states', state);
}

export async function updateHourState(state: Partial<HourState>, id: number): Promise<HourState> {
  return methods.Put(`hours/states/${id}`, state);
}

export async function deleteHourState(id: number): Promise<void> {
  return methods.Delete(`hours/states/${id}`);
}

export async function upsertHourStatePermissions(
  stateId: number,
  permissions: HourStatePermissionsPayload
): Promise<Array<HourStatePermission>> {
  return methods.Post(`states/${stateId}/permissions`, permissions);
}
